import { useEffect } from "react"

export default function Deeplink() {
  const saTrack = (type: string, vc: string) => {
    window.sa.track("deeplink", {
      action: type,
      label: vc,
    })
  }

  useEffect(() => {
    if (window.location.search === "") {
      return
    }

    // https://www.thedylink.com/deeplink?afl=https%3A%2F%2Fgetsnap.link%2FDyoKY3xgTbV&amv=5092810&apn=com.snaptube.premium&link=https%3A%2F%2Fgetsnap.link%2FTXVDDppfyXM&share_arg3=com.whatsapp

    const urlParams = new URLSearchParams(window.location.search)
    const data = urlParams.get("link") || ""
    const scheme = "snaptube"
    const package_name = urlParams.get("apn") || ""
    const fallback = urlParams.get("afl") || ""
    const vc = urlParams.get("vc") || ""

    //  拼接格式  intent://deeplink?link={link}#Intent;scheme=snaptube;package={apn};S.browser_fallback_url={afl};end

    const intentUrl =
      "intent://deeplink?link=" +
      data +
      "#Intent;scheme=" +
      scheme +
      ";package=" +
      package_name +
      ";S.browser_fallback_url=" +
      fallback +
      ";end"

    // console.log("intentUrl", intentUrl)

    saTrack("total", vc)

    // 检测是否为安卓设备
    const isAndroid = /android/i.test(navigator.userAgent)

    if (isAndroid) {
      saTrack("intent", vc)
      // 安卓设备使用 intent 协议
      window.location.href = intentUrl
    } else {
      saTrack("fallback", vc)
      // 非安卓设备直接跳转到兜底页
      window.location.href = fallback
    }

    // 设置一个定时器来检测跳转是否成功
    const timeout = 6000 // 6秒后判断是否跳转成功
    const startTime = Date.now()
    const timeoutRef = setTimeout(() => {
      const endTime = Date.now()
      // 如果页面还在（没有被跳转），且时间差大于 timeout，则认为跳转失败
      if (document.hidden || endTime - startTime < timeout) {
        return
      }
      saTrack("fallback", vc)
      // 跳转失败，跳转到兜底页
      window.location.href = fallback
    }, timeout)

    // 清理定时器
    return () => clearTimeout(timeoutRef)
  }, [])

  return <></>
}
